@if (documentIds().length) {
  @if (userService.permissions().readDocument) {
    <h3 nxHeadline size="m" class="pt-5 pb-2.5">{{ 'documents.title' | translate }}</h3>
    <nx-card class="w-full mb-3.5">
      <div class="flex flex-wrap gap-2.5 lg:flex-row flex-col">
        @for (dui of documentIds(); track $index) {
          <div class="file-row flex items-center">
            <kyc-document-info [attr.data-testid]="'document-' + $index" class="w-full" [dui]="dui" />
          </div>
        }
      </div>
    </nx-card>
  } @else {
    <nx-message context="warning" class="mt-7">{{ 'documents.missing-rights' | translate }}</nx-message>
  }
}
